import _ from 'lodash'
import React, { Component } from 'react'
import logo from '../../assets/images/logo.svg'
import headerStyles from './Header.module.css'

const delta = 5
let navbarHeight = 0

class Header extends Component {
    state = {
      didScroll: true,
      lastScrollTop: 0,
      navClass: headerStyles.navDown,
      menuOpen: false
    };

    componentDidMount() {
      navbarHeight = document.getElementById('header').offsetHeight
      window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
    }

    hideHeader() {
      this.setState({
        navClass: headerStyles.navUp
      })
    }

    showHeader() {
      this.setState({
        navClass: headerStyles.navDown
      })
    }

    getDocHeight() {
      return Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      )
    }

    hasScrolled = () => {
      const st = window.scrollY
      if (Math.abs(this.state.lastScrollTop - st) <= delta) return
      if (st > this.state.lastScrollTop && st > navbarHeight) {
        this.hideHeader()
      } else if (st < this.getDocHeight()) {
        this.showHeader()
      }

      this.setState({
        lastScrollTop: st
      })
    }

    handleScroll = (event) => {
      if (!this.state.menuOpen) {
        this.setState({
          didScroll: true
        })

        const scrolled = _.throttle(() => {
          this.hasScrolled()
        }, 250)
        scrolled()
      } else {
        this.setState({
          didScroll: false
        })
      }
    }

    toogleMenu = () => {
      const menuOpen = !this.state.menuOpen
      this.setState({ menuOpen })
    }

    handleEvent = () => {
    }

    render() {
      const navClass = [headerStyles.header,
        headerStyles.headerLite,
        this.state.navClass]
      return (
        <div>
          <header
            id="header"
            className={navClass.join(' ')}
          >
            <div className={headerStyles.menuLeft}>
              <nav className={headerStyles.logo}>
                <a href={`https://mymoons.mx/blog`}>
                  <img
                    alt="moons"
                    src={logo}
                  />
                </a>
              </nav>
            </div>
          </header>
        </div>
      )
    }
}

export default Header
